<template>
  <b-row>
    <b-col>
      <b-form-group>
        <b-form-checkbox
          :name="fieldName"
          :value="checkedValue"
          :unchecked-value="uncheckedValue"
          :required="required"
          v-bind="$attrs"
          :checked="check"
          @input="updateValue($event)"
          >{{ label }}</b-form-checkbox
        >
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    fieldName: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    checked: {
      type: Boolean,
      required: false,
      default: false
    },
    checkedValue: {
      required: true
    },
    uncheckedValue: {
      required: false,
      defalut: null
    }
  },
  methods: {
    updateValue(val) {
      this.$emit("input", val);
    }
  },
  computed: {
    check() {
      return this.checked ? this.checkedValue : this.uncheckedValue;
    }
  },
  created() {
    let originalValue = this.checked ? this.checkedValue : this.uncheckedValue;

    this.updateValue(originalValue);
  }
};
</script>

<style lang="scss" scoped></style>
